import { render, staticRenderFns } from "./ImagesBrowser.vue?vue&type=template&id=39dbfaf0&scoped=true&"
import script from "./ImagesBrowser.vue?vue&type=script&lang=ts&"
export * from "./ImagesBrowser.vue?vue&type=script&lang=ts&"
import style0 from "./ImagesBrowser.vue?vue&type=style&index=0&id=39dbfaf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dbfaf0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
